import React, { Component } from 'react';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    handleRetry = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={styles.container}>
                    <div style={styles.icon}>!</div>
                    <h1 style={styles.title}>
                        {this.props.language === 'zh' ? '页面加载出错' : 'Something went wrong'}
                    </h1>
                    <p style={styles.message}>
                        {this.props.language === 'zh'
                            ? '请刷新页面重试，如果问题持续存在请联系支持'
                            : 'Please refresh the page. If the problem persists, contact support.'}
                    </p>
                    <button
                        onClick={this.handleRetry}
                        style={styles.button}
                        aria-label={this.props.language === 'zh' ? '重试' : 'Retry'}
                    >
                        {this.props.language === 'zh' ? '重试' : 'Try Again'}
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        padding: '2rem',
        textAlign: 'center',
    },
    icon: {
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        backgroundColor: 'rgba(255, 59, 48, 0.1)',
        color: '#FF3B30',
        fontSize: '2rem',
        fontWeight: '700',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '1.5rem',
    },
    title: {
        fontSize: '1.5rem',
        fontWeight: '700',
        color: '#1D1D1F',
        marginBottom: '0.75rem',
    },
    message: {
        fontSize: '1rem',
        color: '#86868B',
        marginBottom: '1.5rem',
        maxWidth: '400px',
        lineHeight: '1.5',
    },
    button: {
        padding: '12px 28px',
        backgroundColor: '#007AFF',
        color: '#fff',
        border: 'none',
        borderRadius: '12px',
        fontSize: '1rem',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
    },
};

export default ErrorBoundary;
